import { useState } from "react";

export const SizeOptionsField = ({ value, onChange }) => {
  const [text, setText] = useState((value || []).join(", "));
  const enabled = !!value?.length;
  const [editing, setEditing] = useState(enabled);
  const parse = (raw) => [...new Set(raw.split(",").map((size) => size.trim().toUpperCase()).filter(Boolean))];
  return (
    <div className="min-w-0 border-t border-white/10 pt-4 sm:col-span-2">
      <label className="flex items-center gap-2 text-sm text-slate-200">
        <input data-testid="product-form-sizes-enabled" type="checkbox" checked={editing} onChange={(event) => {
          setEditing(event.target.checked);
          const next = text || "S, M, L, XL, XXL";
          setText(next);
          onChange(event.target.checked ? parse(next) : []);
        }} className="h-4 w-4 accent-cyan-400" /> Customer size selection
      </label>
      {editing && <div className="mt-3">
        <label htmlFor="product-form-size-options" className="mb-2 block text-xs text-slate-400">Available sizes · same product price for every size</label>
        <input id="product-form-size-options" data-testid="product-form-size-options" required maxLength={600} value={text} onChange={(event) => { const values = parse(event.target.value); event.target.setCustomValidity(values.length ? "" : "Enter at least one size."); setText(event.target.value); onChange(values); }} placeholder="S, M, L, XL, XXL" className="w-full rounded-xl border border-white/10 bg-[#0A0B0E]/60 px-4 py-2.5 text-sm focus:border-cyan-400/50 focus:outline-none" />
      </div>}
    </div>
  );
};